<template>
  <app-panel :class="$style.panel" :style="panelStyle">
    <div ref="headerPlaceholder" :class="$style.headerPlaceholder"></div>
    <div ref="header" :class="$style.header">
      <div :class="$style.block">
        <slot name="header" />
      </div>
    </div>

    <slot />

    <div :class="$style.footerPlaceholder"></div>
    <div ref="footer" :class="$style.footer">
      <div :class="$style.block">
        <slot name="footer" />
      </div>
    </div>
  </app-panel>
</template>

<script>
export default {
  name:  "FullHeightPanel",
  props: [
    'containerWidth',
    // 'headerHeight',
    // 'footerHeight',
  ],
  data() {
    return {
      lastScrollPosition:  0,
      lastScrollDirection: 'down',
      lastHeaderPosition:  0,
      headerHeight:        0,
      containerOffsetTop:  0,
      footerHeight:        0,
    };
  },
  computed: {
    panelStyle() {
      return {
        '--panel-header-height': this.headerHeight + 'px',
        '--panel-footer-height': this.footerHeight + 'px',
        '--panel-block-width':   this.containerWidth + 'px',
      };
    },
  },
  methods:  {
    setHeaderOffset( offset ) {
      this.$refs.header.style.top = offset + 'px';
      this.lastHeaderPosition = offset;
    },

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY;
        const offsetTop = scrollTop - this.containerOffsetTop;
        const scrollDirection = this.lastScrollPosition > scrollTop ? 'up' : 'down';

        if (scrollDirection === 'up') {
          if (scrollDirection !== this.lastScrollDirection && this.lastHeaderPosition + this.headerHeight < offsetTop) {
            const top = Math.max(offsetTop - this.headerHeight, 0);
            this.setHeaderOffset(top);
          } else if (offsetTop < this.lastHeaderPosition) {
            const top = Math.max(offsetTop, 0);
            this.setHeaderOffset(top);
          }
        }
        this.lastScrollPosition = scrollTop;
        this.lastScrollDirection = scrollDirection;
      });
    },

    updateLayoutMeasure() {
      this.headerHeight = this.$refs.header.getBoundingClientRect().height;
      this.footerHeight = this.$refs.footer.getBoundingClientRect().height;
      this.containerOffsetTop = window.scrollY + this.$refs.headerPlaceholder.getBoundingClientRect().top - 15;
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.updateLayoutMeasure);
    this.updateLayoutMeasure();

    const observer = new MutationObserver(this.updateLayoutMeasure);

    observer.observe(this.$refs.header, { attributes: true, childList: true, subtree: true });
    observer.observe(this.$refs.footer, { attributes: true, childList: true, subtree: true });
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateLayoutMeasure);
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style lang="scss" module>
.panel {
  background: #F6F6F6;
  flex: 1;
  position: relative;
}

.headerPlaceholder {
  height: calc(var(--panel-header-height) - 15px);
}

.header {
  position: absolute;
  background: #fff;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  transform: translateZ(0);
}

.headerFixed {
  position: fixed;
}

.footerPlaceholder {
  height: calc(var(--panel-footer-height) - 30px);
}

.footer {
  position: fixed;
  bottom: 0;
  background: #fff;
  right: 15px;
  left: 274px;
  @include anim(.5s);
  z-index: 1000;

  :global(.content-area-reduced) & {
    left: 94px;
  }

  :global(.content-area-full) & {
    left: 15px;
    //  right: 2.2rem;
    //  left: 2.2rem;
  }
}

.block {
  max-width: calc(var(--panel-block-width) + 30px);
  padding: 15px;
}

</style>
